import { z } from 'zod';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { i18nAttributes, uuid } from '../../utils';

export const publicCurrency = extendApi(
  z.object({
    id: uuid,
    i18nAttributes: i18nAttributes(
      extendApi(
        z.object({
          name: z.string(),
        }),
        {
          examples: [{ name: 'Coins' }, { name: 'Pièces' }],
        },
      ),
    ),
  }),
  {
    description: 'Virtual currency the user can earn or burn for rewards',
    tags: ['currency-model', 'currency', 'model'],
  },
);

export const publicCurrencyRef = extendApi(publicCurrency, {
  $ref: '#/components/schemas/Currency',
} as RedocSchemaObject);

export type PublicCurrency = z.infer<typeof publicCurrency>;
